import { normalize, schema } from 'normalizr'
import Vue from 'vue'

const device = new schema.Entity('children')
const children = new schema.Array(device);
device.define({ children });
const devices = new schema.Entity('devices', { children });


export default {
  state: {
    normdevs: {},
    devices: [],
    currentDevice: {}
  },

  mutations: {
    updateDevices(state, devices) {
      state.devices = devices
    },
    updateCurrentDevice(state, currentDevice) {
      state.currentDevice = currentDevice
    },
    setNormDevs(state, normdevs) {
      state.normdevs = normdevs
    },
    toggleNode(state, node) {
      if (state.normdevs[node.id].isOpen === undefined) {
        state.normdevs[node.id].isOpen = false
      }
      node = {...node, isOpen: !state.normdevs[node.id].isOpen}
      Vue.set(state.normdevs, node.id, node)
    }
  },

  actions: {
    async getDevices({ commit }) {
      try {
        const response = await this._vm.$http.get('devices')
        commit('updateDevices', response.data.devices)

        const normdevs = normalize({children: response.data.devices}, devices)
        commit('setNormDevs', normdevs.entities.children)

      } catch (error) {
        console.log(error)
      }
    },
    updateCurrentDevice({ commit }, currentDevice) {
      commit('updateCurrentDevice', currentDevice)
    },
    toggleNode({ commit }, node) {
      commit('toggleNode', node)
    }
  },

  getters: {
    devices(state) {
      return state.devices
    },
    normdevs(state) {
      return state.normdevs
    },
    currentDevice(state) {
      return state.currentDevice
    }
  }
}
